function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 1818;


//////////////////
// WEBPACK FOOTER
// (webpack)/hot nonrecursive ^\.\/log$
// module id = 1818
// module chunks = 0